﻿let defaults = {
    Accordion: {
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    ActionBar: {
        buttonStyle: "link",
        buttonColor: "background",
        iconSize: 24,
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Build: {
        idBuildType: 0,
        idQueue: 1,
        cloudBuild: true,
    },
    Button: {
        ruleType: "button",
        enabled: true,
        iconStyle: "none",
        textPosition: "right",
        buttonStyle: "normal",
        color: "background",
        imageHeight: 30,
        imageWidth: 30,
        showLabel: true,
        fullWidth: false,
        relativeWidth: "auto",
        useZeroPadding: false,
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Configurator: {
        entityType: "product",
        unitOfMeasure: "ea.",
        price: 0.0,
        cost: 0.0,
        maxDiscountPercentage: 0.0,
        maxQty: 0.0,
        minQty: 1.0,
        allowFractionalQty: false,
        score: 0,
        usePartSelector: false,
        active: true,
        inheritCategoryPermissions: false,
        v: 0,
        snapVersion: 0,
        visible: true,
        alwaysChild: false,
        validationTiming: "always",
        allowSaveWithErrors: true,
        idLayout: -1,
        useMobileDropdowns: true,
        headerColor: "header",
        showMoveAnimation: false,
        viewerMode: "none",
        clearMemoryWhenSwitchingScenes: false,
        sceneToolbarPosition: "bottomRight",
        nestedSceneClickToSelect: true,
        runQuoteRuleUponInsert: false,
        imageSource: "none",
        allowUserToRemove: false,
        bubbleRules: false,
        hasPricingRule: false,
        hasQuoteRule: false,
        autoValidation: true,
        convertToKb3d: false,
        mouseOverEffects: true,
        mouseOverColor: "#131313",
        prefetchImages: true,
        allowOrbit: true,
        allowPan: true,
        allowZoom: true,
        constrainCameraToRadius: false,
        cameraRadius: 0.0,
        isPlaceholder: false,
        scroll: "none",
        itemLayout: "horizontal",
        itemAlignment: "stretch",
        itemJustify: "start",
        spaceBetweenItems: "none",
        padding: "none",
        collapseOnMobile: false,
        backgroundColor: "background",
        backgroundShade: "default",
        backgroundOpacity: 1.0,
        elevation: "none",
        relativeSize: "x1",
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        alignment: "inherit",
    },
    ConfiguratorAction: {
        iconStyle: "icon",
        textPosition: "right",
        visible: true,
        enabled: true,
        ruleType: "action",
        showLabel: true,
        relativeSize: "auto",
    },
    ConfiguratorFunction: {
        ruleType: "action",
    },
    Container: {
        isPlaceholder: false,
        scroll: "none",
        itemLayout: "horizontal",
        itemAlignment: "stretch",
        itemJustify: "start",
        spaceBetweenItems: "none",
        padding: "none",
        collapseOnMobile: false,
        backgroundColor: "background",
        backgroundShade: "default",
        backgroundOpacity: 1.0,
        elevation: "none",
        relativeSize: "x1",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        alignment: "inherit",
    },
    DropdownButton: {
        ruleType: "button",
        enabled: true,
        iconStyle: "none",
        textPosition: "right",
        buttonStyle: "normal",
        color: "background",
        imageHeight: 30,
        imageWidth: 30,
        showLabel: true,
        fullWidth: false,
        relativeWidth: "auto",
        useZeroPadding: false,
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Expander: {
        expanded: true,
        iconStyle: "icon",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Field: {
        ruleType: "field",
        enabled: true,
        required: false,
        type: "text",
        control: "none",
        searchable: false,
        showLabel: true,
        mask: "none",
        precision: 2,
        constrainValue: false,
        min: 0,
        max: 0,
        step: 0,
        sliderAllowDirectEdit: false,
        sliderValueVisibility: "visible",
        dateFormat: "Y-m-d",
        format: "none",
        formatMinPrecision: 0,
        formatCurrency: "USD",
        formatDecimalSeparator: ".",
        formatThousandsSeparator: ",",
        selectSource: "simple",
        autoCompleteSource: "table",
        useFullTextSearch: false,
        constrainToSource: true,
        sort: "none",
        imageHeight: 30,
        imageWidth: 30,
        imageOnly: false,
        optionLayout: "wrap",
        dropdownOptionLayout: "vertical",
        enableSelectedImages: false,
        linkToDynamicAttribute: false,
        useZeroPadding: false,
        hasBeenTouched: false,
        uploadToScene: false,
        convertUploadedSceneImageToMesh: false,
        convertUploadPdfToImage: false,
        uploadImageThreshold: 0.5,
        iconStyle: "icon",
        buttonStyle: "normal",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    GridColumn: {
        relativeWidth: "x1",
        verticalAlignment: "stretch",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    GridRow: {
        verticalAlignment: "stretch",
        horizontalAlignment: "left",
        spaceBetweenItems: "medium",
        collapseOnMobile: true,
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Group: {
        enabled: true,
        showLabel: true,
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Hotspot: {
        target: true,
        popupPosition: "target",
        popupAttach: "center",
        keepPopupInViewer: true,
        popupOffsetX: 0,
        popupOffsetY: 0,
        popupTop: "auto",
        popupLeft: "auto",
        popupBottom: "auto",
        popupRight: "auto",
        popupWidth: "auto",
        popupHeight: "auto",
        visible: true,
        open: false,
        alpha: 1,
        allowClose: true,
        showPopupHeader: true,
        showPopupBackground: true,
        showTooltip: true,
        targetColor: "#0A6080",
        targetShape: "circle",
        targetSize: 18,
        source: "text",
        animationDuration: 1000,
        animationEasing: "easeOutCirc",
    },
    Html: {
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    KbObject: {
    },
    LayoutConfig: {
        autoValidation: true,
        useMobileDropdowns: true,
        isPlaceholder: false,
        scroll: "none",
        itemLayout: "horizontal",
        itemAlignment: "stretch",
        itemJustify: "start",
        spaceBetweenItems: "none",
        padding: "none",
        collapseOnMobile: false,
        backgroundColor: "background",
        backgroundShade: "default",
        backgroundOpacity: 1.0,
        elevation: "none",
        relativeSize: "x1",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        alignment: "inherit",
    },
    LayoutContent: {
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Media: {
        maxHeight: 256,
        maxWidth: 256,
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    MethodOfManufacture: {
    },
    MethodOfManufactureRuleContainer: {
    },
    NestedSet: {
        display: "accordion",
        autoNavigateToElement: true,
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    OptionFilter: {
        ruleType: "optionFilter",
        source: "table",
        optimized: true,
        level: 0,
        queryMode: "table",
        singleOptionBehavior: "nothing",
        visibleToChildren: false,
    },
    BomMappingField: {
    },
    CadAnnotationField: {
        markedForDrawing: false,
    },
    CadBlockArrayField: {
        insertionPointX: 0,
        insertionPointY: 0,
        insertionPointZ: 0,
        xScale: 1,
        yScale: 1,
        zScale: 1,
        rotation: 0,
        flipX: false,
        flipY: false,
        numRows: 1,
        rowSpacing: 1,
        numColumns: 1,
        columnSpacing: 1,
    },
    CadBlockField: {
        insertionPointX: 0,
        insertionPointY: 0,
        insertionPointZ: 0,
        xScale: 1,
        yScale: 1,
        zScale: 1,
        rotation: 0,
        flipX: false,
        flipY: false,
    },
    CadComponentField: {
        suppressed: false,
        deleted: false,
    },
    CadCustomPropertyField: {
    },
    CadDimensionField: {
        markedForDrawing: false,
        value: 0,
    },
    CadDrawingAnnotationField: {
        x: 0,
        y: 0,
        visible: true,
    },
    CadDrawingDimensionField: {
        visible: true,
        x: 0,
        y: 0,
    },
    CadDrawingSheetField: {
        scaleNumerator: 1,
        scaleDenominator: 1,
        useCustomScale: false,
        deleted: false,
        scaleAnnoPosition: false,
        scaleAnnoTextHeight: false,
    },
    CadDrawingViewField: {
        useCustomScale: false,
        autoPositionAnnotations: false,
        scaleNumerator: 1,
        scaleDenominator: 1,
        autosize: false,
        autoDimension: false,
        autoBalloon: false,
        ignoreMultipleBalloons: true,
        deleted: false,
        suppressed: false,
        autoPosition: true,
        x: 0,
        y: 0,
        bomRenumber: false,
        allowMultipleBalloonsFirstLevelOnly: true,
        referencedPartFamily: "",
    },
    CadDynamicComponentField: {
        suppressed: false,
        fixed: false,
    },
    CadDynamicDrawingAnnotationField: {
        x: 0,
        y: 0,
    },
    CadDynamicDrawingDimensionField: {
        x: 0,
        y: 0,
        vertical: false,
        dimensionTextPrefix: false,
    },
    CadFeatureField: {
        suppressed: false,
        deleted: false,
    },
    CadLayerField: {
        lineType: "BYLAYER",
        toAdd: true,
        active: true,
        freeze: false,
        lineWeight: "lnWtByBlock",
        lock: false,
        plottable: true,
        visible: true,
    },
    CadLibFeatureField: {
    },
    CadParameterField: {
        value: 0,
    },
    CadReplaceComponentField: {
    },
    CadRepresentationField: {
    },
    CadScaleFeatureField: {
        x: 1,
        y: 1,
        z: 1,
        isUniform: true,
        scaleUniform: 1,
        suppressed: false,
        deleted: false,
    },
    CadTextField: {
        insertionPointX: 0,
        insertionPointY: 0,
        insertionPointZ: 0,
        height: 0,
    },
    CadAngleMate: {
        angle: 0,
        aligned: false,
        alignClosest: false,
    },
    CadCoincidentMate: {
        aligned: false,
        alignClosest: false,
    },
    CadCoordinateSystemMate: {
        aligned: false,
        alignClosest: false,
    },
    CadDistanceMate: {
        distance: 0,
        aligned: false,
        alignClosest: false,
    },
    CadLibDimension: {
        value: 0,
    },
    CadLibReference: {
        referenceType: "0",
    },
    CadPoint: {
    },
    CadPositionConstraint: {
        x: 0,
        y: 0,
        z: 0,
        xAngle: 0,
        yAngle: 0,
        zAngle: 0,
        aligned: false,
        alignClosest: false,
    },
    Constraint: {
    },
    Mate: {
        aligned: false,
        alignClosest: false,
    },
    ExcelCellField: {
        deleted: false,
    },
    ExcelChartField: {
        deleted: false,
    },
    ExcelImageField: {
    },
    ExcelSheetField: {
        deleted: false,
        tryCalculateFormula: false,
        autoFitColumns: false,
        autoFitRows: false,
    },
    ExcelTableField: {
        deleted: false,
    },
    OutputField: {
    },
    PdfSectionField: {
        source: "tag",
        idTag: 0,
        nestedIdProduct: 0,
    },
    TableOutputField: {
    },
    WordContainerField: {
        deleted: false,
    },
    WordImageField: {
        deleted: false,
        fixContentControlSize: false,
    },
    WordListField: {
        deleted: false,
    },
    WordTextField: {
        deleted: false,
    },
    ZipSectionField: {
        source: "tag",
        idTag: 0,
        nestedIdProduct: 0,
    },
    BomOutput: {
        mode: "empty",
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    CadDrawingOutput: {
        fileNameAsTopModelName: false,
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    CadOutput: {
        hideCADApplication: false,
        closeCADatEnd: false,
        maxBuildTime: 600,
        copyAllFiles: false,
        deleteOldFiles: false,
        modifyDimensionInAllConfig: true,
        createBOM: false,
        creoVersion: 3,
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    ExcelOutput: {
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    Export: {
        enabled: true,
        postToCloud: true,
    },
    FileOutput: {
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    GlbOutput: {
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    ImageOutput: {
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    Output: {
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    PdfOutput: {
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    RenderPassExport: {
        frameCamera: true,
        framePadding: 1,
        allowEmpty: false,
        width: 800,
        height: 600,
        enabled: true,
        postToCloud: true,
    },
    SceneRenderOutput: {
        frameCamera: true,
        framePadding: 1,
        allowEmpty: false,
        width: 800,
        height: 600,
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    SvgOutput: {
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    TextOutput: {
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    WordOutput: {
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    ZipOutput: {
        ruleType: "output",
        enabled: true,
        autoValidation: true,
    },
    Page: {
        enabled: true,
        iconStyle: "icon",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    PageControl: {
        padding: "large",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    PageNavigator: {
        buttonStyle: "normal",
        buttonColor: "background",
        showPageLabel: true,
        labelColor: "normal",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    PageTabs: {
        orientation: "vertical",
        tabStyle: "cards",
        iconSize: 34,
        tabWidth: "custom",
        customTabWidth: 63,
        showTabLabels: true,
        backgroundColor: "background",
        backgroundShade: "default",
        selectionStyle: "background",
        selectionColor: "accent",
        selectionShade: "default",
        selectionLineColor: "accent",
        elevation: "none",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Popup: {
        popupWidth: "auto",
        popupHeight: "auto",
        ruleType: "button",
        enabled: true,
        iconStyle: "none",
        textPosition: "right",
        buttonStyle: "normal",
        color: "background",
        imageHeight: 30,
        imageWidth: 30,
        showLabel: true,
        fullWidth: false,
        relativeWidth: "auto",
        useZeroPadding: false,
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    PriceWidget: {
        showDetails: true,
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    PricingRuleContainer: {
        requiresUpdate: false,
        fillFromSource: "none",
    },
    ReferencedConfigurator: {
        nestScene: true,
        nestHotspots: false,
        nestPriceObject: true,
        nestMethodOfManufacture: true,
    },
    Rule: {
    },
    RuleContainer: {
    },
    SvgViewer: {
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Tab: {
        showLabel: true,
        iconStyle: "icon",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    TabControl: {
        tabWidth: "auto",
        customTabWidth: 63,
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Text: {
        style: "normal",
        color: "normal",
        weight: "f400",
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Toolbar: {
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    UiObject: {
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    Viewer: {
        visible: true,
        left: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        width: "auto",
        height: "auto",
        opacity: 1.0,
        order: 0,
        relativeSize: "auto",
        alignment: "inherit",
    },
    ProductRuleContainer: {
        autoValidation: true,
    },
};
export { defaults };